import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  message,
  Spin,
  Alert,
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import 'moment/locale/th';
import TextArea from 'antd/lib/input/TextArea';
import axios from 'axios';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../../../layouts/User';
import {
  getCities,
  getPostalCodes,
  getStates,
  getSubCities,
} from '../../../services/api';
import styles from './index.module.scss';
import LocationAddress from '../../../services/locations/location-address';
import DistanceService from '../../../services/locations/distance-service';
import { Loader, LoaderOptions } from 'google-maps';
import { API_KEY } from '../../../config';
import OverwriteMomentBE from '../../../services/picker/OverwriteMomentBE';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides';
type overridesNameToClassKey = {
  [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};
declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey
    extends overridesNameToClassKey {}
}
const options: LoaderOptions = {
  /* todo */
};
const loader = new Loader(API_KEY, options);

export type Props = {};

moment.locale('th');

const breadcrumbs = [
  {
    text: 'หน้าแรก',
    path: '/',
  },
  {
    text: 'ตะกร้าสินค้า',
    path: '/cart',
  },
  {
    text: 'สรุปรายการสั่งซื้อ',
    path: '/confirm-order-summary',
  },
];

const OrderSummary: React.FC<Props> = (props) => {
  let [searchParams, setSearchParams] = useSearchParams();
  let [orders, setOrders] = useState<any>([]);
  const [isReadOnly, setIsReadOnly] = useState<boolean>(false);
  const [isReset, setIsReset] = useState<boolean>(false);

  let [shipment, setShipment] = useState<any>([]);
  let [isOptionsDeliver, setOptionsDeliver] = useState<any>([]);
  let [shipmentprice, setShipmentprice] = useState<any>([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  let [formAddresses] = Form.useForm();
  let [formAddress] = Form.useForm();
  const user = useSelector((state: any) => state.user);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [isSetting, setSetting] = useState<any>({});
  const [subCitiesCheck, setSubCitiesCheck] = useState<any>('');
  const [profileImage, setProfileImage] = useState<any>('');
  const [profileName, setProfileName] = useState<any>('');
  const [IndexShop, setIndexShop] = useState<number>(0);
  const [orderTotalPrice, setOrdersTotalPrice] = useState<number>(0);
  const [postalCodes, setPostalCodes] = useState<any>([]);
  const [subCities, setSubCities] = useState<any>([]);
  const [cities, setCities] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [isCarts, setCarts] = useState<any>([]);
  const [currentAddresses, setCurrentAddresses] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isCurrentLocationLoading, setIsCurrentLocationLoading] =
    useState<boolean>(false);
  const [isAddressLocation, setIsAddressLocation] =
    useState<boolean>(false);
  const [isProcessLoading, setIsProcessLoading] =
    useState<boolean>(false);
  const [editDateTranfer, setEditDatetranfer] = useState<any>();
  const [isLocationFromCurrent, setIsLocationFromCurrent] =
    useState<boolean>(true);

  const currentAddress = useSelector(
    (state: any) => state.currentAddress
  );
  const { currentLocation } = useSelector((state: any) => state);

  const [state, setState] = useState<any>({
    addresseses: [
      {
        shipmentDate: null,
      },
    ],
    addresses: [
      {
        address: null,
        subCity: null,
        city: null,
        state: null,
        postalCode: null,
        isCurrent: false,
      },
    ],
  });
  const { Option } = Select;

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const totalPrice = () => {
    const aaa = orders.map((x: any) => x.totalPrice);
    let total = 0;
    for (let i = 0; i < aaa.length; i++) {
      total = total + aaa[i];
    }
    setOrdersTotalPrice(total);
  };

  const totalPrices = () => {
    orders.map(
      (y: any) =>
        (y.totalPrice =
          y.totalPriceDefault + (y.shipment ? y.shipment : 0))
    );
    const totalPrices = orders.map((x: any) => x.totalPrice);

    let total = 0;
    for (let i = 0; i < totalPrices.length; i++) {
      total = total + totalPrices[i];
    }

    setOrdersTotalPrice(total);
  };

  const getOrder = async () => {
    const shopProducts = await axios.get(
      `/orders/${searchParams.get('id')}`
    );
    const odrs = shopProducts.data.map((x: any) => ({
      ...x,
      totalPriceDefault: x.totalPrice,
      products: x?.products.map((y: any) => ({ ...y, box: 0 })),
    }));
    const { data } = await axios.get(`/settings`);

    let coloursList = [];
    for (const index in odrs) {
      const List = [];
      if (odrs[index]?.shop?.normalDelivery) {
        List.push({ value: 'จัดส่งปกติ', ladel: 'จัดส่งปกติ' });
      }
      if (odrs[index]?.shop?.specialDelivery) {
        List.push({ value: 'จัดส่งพิเศษ', ladel: 'จัดส่งพิเศษ' });
      }
      if (odrs[index]?.shop?.receiveDelivery) {
        List.push({ value: 'รับที่ร้าน', ladel: 'รับที่ร้าน' });
      }
      coloursList.push(List);
    }

    setSetting(data.data);
    setOrders(odrs);
    mapShopProducts(odrs);
    setOptionsDeliver(coloursList);
    if (odrs) {
      if (odrs[0].status === 'waiting_payment') {
        navigate(`/profile/my-order`);
      }
    }
  };

  const mapShopProducts = async (orders: any) => {
    let setOrders = orders.map((x: any) => ({
      ...x,
      checkorder: x?.products?.map((y: any) => ({
        ...y,
        box: 0,
        checkShipment: y?.product?._id?.shipment?.shipmentType,
        checkShipmentArea:
          y?.product?._id?.shipment?.shipmentTypeFreeSomeAreas,
      })),
    }));
    setShipment(setOrders);
  };

  const getCarts = async (id: any) => {
    let { data } = await axios.get(`/carts/${id}`);
    if (!data) {
      return;
    }

    setCarts(data);
    getShopSettingShipment(data.shops[0].shop._id);
  };

  // Implement check seller setting free shipment
  interface ISellerSettingShipment {
    isFreeShipping: boolean;
    minimumPurchase: number;
  }
  const [sellerSettingShipment, setSellerSettingShipment] =
    useState<ISellerSettingShipment>();
  const getShopSettingShipment = async (shopId: string) => {
    let { data } = await axios.get(
      `/sellerSettings/shipment/${shopId}`
    );
    setSellerSettingShipment(data.data);
  };

  const updateOrder = async (values: any) => {
    let totalPrice = orderTotalPrice;
    if (discount.type === 'discount') {
      totalPrice =
        orderTotalPrice -
        (discount.type === 'discount' ? discount.amount : 0);
    }
    const data = {
      address: {
        address: values.address,
        city: values.city,
        postalCode: values.postalCode,
        state: values.state,
        subCity: values.subCity,
      },
      status: 'waiting_payment',
      totalPrice: totalPrice,
    };

    const shops = JSON.parse(JSON.stringify(isCarts.shops));

    for (const shop of isCarts.shops) {
      for (const product of shop.products) {
        for (const order of orders) {
          for (const productsOrder of order.products) {
            if (product._id === productsOrder._id) {
              const nShop = shops.find((x: any) =>
                x.products.find((y: any) => y._id === product._id)
              );
              const index = nShop.products.findIndex(
                (x: any) => x._id === product._id
              );
              nShop.products.splice(index, 1);
            }
          }
        }
      }

      const objShop = shops.find((x: any) => x._id === shop._id);
      if (!objShop.products.length) {
        const index = shops.findIndex(
          (x: any) => x._id === objShop._id
        );
        shops.splice(index, 1);
      }
    }

    const addCart = shops.map((x: any) => ({
      shop: x?.shop?._id,
      products: x.products.map((y: any) => ({
        amount: y.amount,
        product: y?.product?._id,
      })),
    }));

    const bodyCart = {
      userId: user._id,
      shops: addCart,
    };
    try {
      setLoading(true);
      await axios.patch(`/orders/${searchParams.get('id')}`, data);
      await axios.patch(`/carts/new-cart/${isCarts._id}`, bodyCart);
      updateOrderShop(values);
      setStockProduct();
      /** Redeem Promotion */
      if (discount.type !== '') {
        await axios.patch(`/promotions/redeem`, {
          code: promotionCode,
          userId: user._id,
          orderId: searchParams.get('id'),
        });
      }
      /** End Redeem Promotion */
    } catch (err) {
      message.error('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งภายหลัง!');
      setLoading(false);
    }
  };

  const setStockProduct = async () => {
    const userProductsIdArray: any[] = [];
    orders.map((x: any) => {
      x.products.map((y: any) => {
        const obj = {
          userProductId: y.product._id._id,
          newStock: y.product._id.stock - y.amount,
        };
        userProductsIdArray.push(obj);
      });
    });
    if (userProductsIdArray.length) {
      for (let i = 0; i < userProductsIdArray.length; i++) {
        const dataOrderShop = {
          stock: userProductsIdArray[i].newStock,
        };
        await axios.patch(
          `/user-product/${userProductsIdArray[i].userProductId}`,
          dataOrderShop
        );
      }
    }
  };

  const nextPage = () => {
    updateToDelete();
    navigate(`/cart/confirm-payment?id=${searchParams.get('id')}`);
  };

  const updateOrderShop = async (values: any) => {
    let promotionData = {};
    if (usePromotion) {
      try {
        const response = await axios.get(
          `/promotions/verify/${promotionCode}`
        );
        promotionData = response.data.data;
      } catch (error) {}
    }
    const promotion = {
      shipment_discount:
        discount.type === 'discount_shipping' ? discount.amount : 0,
      discount: discount.type === 'discount' ? discount.amount : 0,
      promotion_type: discount.type,
    };
    for (const order in orders) {
      let totalPrice = orders[order].totalPrice
        ? orders[order].totalPrice
        : 0;
      if (discount.type === 'discount') {
        totalPrice = totalPrice - promotion.discount;
      }
      const data = {
        ...promotion,
        promotion: promotionData,
        totalPrice,
        status: 'waiting_payment',
        remark: orders[order].remark ? orders[order].remark : '',
        shipment: orders[order].shipment ? orders[order].shipment : 0,
        deliveryType: orders[order].delivery
          ? orders[order].delivery
          : '',
        shipmentDate: orders[order].shipmentDate
          ? orders[order].shipmentDate
          : '',
        shipmentTime: orders[order].shipmentTime
          ? orders[order].shipmentTime
          : '',
        shippingPrice: orders[order].shippingPrice
          ? orders[order].shippingPrice
          : '',
      };
      await axios.patch(`/ordershops/${orders[order]._id}`, data);
    }
    setTimeout(nextPage, 1500);
  };
  const updateToDelete = async () => {
    await axios.delete(`/orders/delete/${user._id}`);
    await axios.delete(`/ordershops/delete/${user._id}`);
  };

  const confirmButton = async (values: any) => {
    if (isPromotionError) {
      Modal.confirm({
        title: 'ท่านใส่โค้ดส่วนลดไม่ถูกต้อง',
        icon: <ExclamationCircleOutlined />,
        content: 'กดชำระเงินเพื่อชำระเงินโดยไม่ใช้โค้ดส่วนลด',
        okText: 'ชำระเงิน',
        cancelText: 'แก้ไขโค้ดส่วนลด',
        onOk: () => updateOrder(values),
        onCancel: () => {},
      });
    } else {
      updateOrder(values);
    }
  };

  const selectAddress = async (index: any) => {
    onPostalCodeProfileChangeBox(
      state.addressesLocation[index]?.postalCode
    );
    formAddresses.setFieldsValue({
      ...state.addressesLocation[index],
      postalCode: state.addressesLocation[index]?.postalCode,
      subCity: state.addressesLocation[index]?.subCity,
      city: state.addressesLocation[index]?.city,
      state: state.addressesLocation[index]?.state,
    });
    for (let i = 0; i < orders.length; i++) {
      orders[i].shipment = 0;
    }

    setIsLocationFromCurrent(false);

    handleCancel();
  };

  const onRemarkChange = (e: any, item: any, index: number) => {
    const value = e.target.value;
    const newOrders = orders;
    newOrders[index].remark = value;
    setOrders(newOrders);
  };

  const onDatePickerChange = (
    value: any,
    item: any,
    index: number
  ) => {
    const dateString = moment(value).format('DD/MM/YYYY');
    const newOrders = orders;
    newOrders[index].shipmentDate = value;
    setEditDatetranfer(dateString);
    setOrders(newOrders);
  };

  const onTimePickerChange = (
    value: any,
    item: any,
    index: number
  ) => {
    let dateTimeUpdate = {};
    if (editDateTranfer) {
      const NewTranDate = editDateTranfer.split('/');
      const NewTranTime = value.split('/');
      const dateTranferUpdate = new Date(
        NewTranDate[2],
        NewTranDate[1],
        NewTranDate[0],
        NewTranTime[0],
        NewTranTime[1],
        0,
        0
      );
      dateTimeUpdate = dateTranferUpdate;
    } else {
      const NewTranTime = value.split('/');
      const dateTranferUpdate = new Date(
        0,
        0,
        0,
        NewTranTime[0],
        NewTranTime[1],
        0,
        0
      );
      dateTimeUpdate = dateTranferUpdate;
    }
    const newOrders = orders;
    newOrders[index].shipmentTime = dateTimeUpdate;
    setOrders(newOrders);
  };

  const getPostalCodesAPI = async () => {
    setPostalCodes(await getPostalCodes());
  };

  const onPostalCodeChange = async (
    value: any,
    isChangeFromCurrentLocation = false
  ) => {
    if (value) {
      setSubCities(await getSubCities(value));
    } else {
      formAddress.setFieldsValue({
        subCity: null,
        city: null,
        state: null,
      });
      setSubCities([]);
      setCities([]);
      setStates([]);
    }

    if (IndexShop) {
      const obj: any = {};
      for (let i = 0; i < IndexShop; i++) {
        obj[`shipment${i}`] = null;
      }
      formAddresses.setFieldsValue(obj);
    }
  };

  const onPostalCodeChangeBox = async (value: any) => {
    if (value) {
      setSubCities(await getSubCities(value));
    } else {
      formAddress.setFieldsValue({});
      setSubCities([]);
      setCities([]);
      setStates([]);
    }

    if (IndexShop) {
      const obj: any = {};
      for (let i = 0; i < IndexShop; i++) {
        obj[`shipment${i}`] = null;
      }
      formAddresses.setFieldsValue(obj);
      formAddresses.setFieldsValue({
        subCity: null,
        city: null,
        state: null,
      });
    }
  };
  const onPostalCodeProfileChangeBox = async (value: any) => {
    if (value) {
      setSubCities(await getSubCities(value));
    } else {
      formAddress.setFieldsValue({});
      setSubCities([]);
      setCities([]);
      setStates([]);
    }

    if (IndexShop) {
      const obj: any = {};
      for (let i = 0; i < IndexShop; i++) {
        obj[`shipment${i}`] = null;
      }
      formAddresses.setFieldsValue(obj);
      formAddresses.setFieldsValue({});
    }
  };

  const checkIsInAll = async ({ product, subCityId }: any) => {
    const objShipment = product?.product?._id?.shipment;
    const { data } = await axios.get(
      `/shipments/check-subcity-is-in-all?subCityId=${subCityId}&shipmentId=${objShipment._id}`
    );
    return data;
  };

  const setShipments = async (
    objCartShop: any,
    index: number,
    value: any,
    subCityId: any
  ) => {
    let productBoxs = null;
    setIsProcessLoading(true);
    const google = await loader.load();
    if (value === 'จัดส่งปกติ') {
      let productBox = [];
      for (let objShipment of objCartShop?.checkorder) {
        let isSetNull = false;
        for (let objShipmentArea of objShipment?.checkShipmentArea) {
          let objShipmentBox = objShipmentArea?.subCities.find(
            (x: any) => x === subCityId
          );
          if (!objShipmentBox) {
            const box = {
              ...objShipment,
              box: objShipment.box + 1,
            };
            objShipment = box;

            if (box.box === box?.checkShipmentArea?.length) {
              isSetNull = true;
            }
          }
        }

        const objIsInAll = await checkIsInAll({
          product: objShipment,
          subCityId,
        });
        const isInAll = objIsInAll?.isAllowed ? true : false;

        objShipment.isInAll = isInAll;
        objShipment.objArea = objIsInAll?.objArea;

        if (isSetNull && !isInAll) {
          const obj: any = {};
          obj[`shipment${index}`] = null;
          formAddresses.setFieldsValue(obj);
        }
        productBox.push(objShipment);
      }

      let Check = 0;
      for (const checkproductBox of productBox) {
        if (
          checkproductBox.box ===
            checkproductBox.checkShipmentArea?.length &&
          !checkproductBox.isInAll
        ) {
          Check = Check + 1;
        }
      }

      if (Check === 0) {
        objCartShop = {
          ...objCartShop,
          priceShipment: objCartShop?.checkorder
            .map((y: any) => 0)
            .reduce((acc: number, curr: number) => {
              return acc + curr;
            }, 0),
          delivery: value,
        };
      }

      let priceShipment = objCartShop?.priceShipment;

      const freeShipmentMinimumPurchase =
        sellerSettingShipment?.minimumPurchase || 0;

      const isSellerFreeShipment =
        sellerSettingShipment?.isFreeShipping;

      const totalAmountExcludeFreeShipping = productBox
        .filter((product) => {
          const isProductFreeShipping =
            product.product._id.isFreeShipping === undefined
              ? true
              : product.product._id.isFreeShipping;
          return isSellerFreeShipment && isProductFreeShipping;
        })
        .reduce(
          (previous, current) =>
            previous + current.amount * current.wholesalePrice,
          0
        );

      for (const product of productBox) {
        const isProductFreeShipping =
          product.product._id.isFreeShipping === undefined
            ? true
            : product.product._id.isFreeShipping;
        if (
          isSellerFreeShipment &&
          isProductFreeShipping &&
          Number(totalAmountExcludeFreeShipping) >=
            Number(freeShipmentMinimumPurchase)
        ) {
          continue;
        }

        let shipment = 0;
        const obj = product.objArea;

        if (!obj) {
          continue;
        }

        if (product?.checkShipment === 'free_some_area') {
          const price = obj.price;
          shipment = price;
        } else if (product?.checkShipment === 'base_on_quantity') {
          const quantity = product?.amount;
          if (quantity <= obj?.base?.firstQuantity) {
            shipment = obj?.base?.firstPrice;
          } else {
            const amountRemain = quantity - obj?.base?.firstQuantity;
            let amountRate = Math.ceil(
              amountRemain / obj?.base?.nextQuantity
            );
            const piece =
              obj?.base?.firstPrice +
              amountRate * obj?.base?.nextPrice;
            shipment = piece;
          }
        } else if (product?.checkShipment === 'base_on_weight') {
          const weight =
            product?.product?._id?.product?.productWeight;
          const weightAll = weight * product?.amount;
          if (weightAll <= obj?.base?.firstQuantity) {
            shipment = obj?.base?.firstPrice;
          } else {
            const amountRemain = weightAll - obj?.base?.firstQuantity;
            let amountRate = Math.ceil(
              amountRemain / obj?.base?.nextQuantity
            );
            const piece =
              obj?.base?.firstPrice +
              amountRate * obj?.base?.nextPrice;
            shipment = piece;
          }
        } else if (product?.checkShipment === 'base_on_distance') {
          const postalCode =
            formAddresses.getFieldValue('postalCode');
          const stateId = formAddresses.getFieldValue('state');
          const subCity = subCities.find(
            (x: any) => x.value === subCityId
          );
          const state = states.find((x: any) => x.value === stateId);
          const shopLocation = {
            lat: objCartShop?.shop?.lat,
            long: objCartShop?.shop?.long,
          };

          const address = `${postalCode} ${subCity.label} ${state.label}`;
          let location = { ...currentLocation };

          if (!isLocationFromCurrent) {
            location = await LocationAddress({
              google,
              address,
              isAllResponse: false,
            });
          }

          let dt: any = await DistanceService({
            google,
            from: [`${location.lat}, ${location.long}`],
            to: [`${shopLocation.lat}, ${shopLocation.long}`],
          });

          let distance: any = 0;
          if (dt?.rows && dt?.rows.length) {
            const element = dt.rows[0].elements[0];

            if (element.status === 'OK') {
              distance = element.distance.value / 1000;
            }
          }
          distance = Math.ceil(distance);
          if (distance <= obj?.base?.firstQuantity) {
            shipment = obj?.base?.firstPrice;
          } else {
            const amountRemain = distance - obj?.base?.firstQuantity;
            let amountRate = Math.ceil(
              amountRemain / obj?.base?.nextQuantity
            );
            const piece =
              obj?.base?.firstPrice +
              amountRate * obj?.base?.nextPrice;
            shipment = piece;
          }
        }
        priceShipment += shipment;
      }

      objCartShop = {
        ...objCartShop,
        priceShipment,
      };
      if (productBox) {
        productBoxs = productBox;
      }
    } else if (value === 'จัดส่งพิเศษ') {
      for (const objShipment of objCartShop?.checkorder) {
        for (const objShipmentArea of objShipment?.checkShipmentArea) {
          const objShipmentBox = objShipmentArea?.subCities.find(
            (x: any) => x === subCityId
          );
          if (!objShipmentBox) {
            message.warning('นอกเหนือพื้นที่ให้บริการจัดส่ง');
            const obj: any = {};
            obj[`shipment${index}`] = null;
            formAddresses.setFieldsValue(obj);
          }
        }
      }
      objCartShop = {
        ...objCartShop,
        priceShipment:
          objCartShop?.checkorder
            .map((y: any) =>
              y.checkShipment === 'free_some_area'
                ? y?.checkShipmentArea?.find((z: any) =>
                    z?.subCities?.find((a: any) => a === subCityId)
                  )
                  ? y?.checkShipmentArea?.find((z: any) =>
                      z?.subCities?.find((a: any) => a === subCityId)
                    ).price
                  : 0
                : 0
            )
            .reduce((acc: number, curr: number) => {
              return acc + curr;
            }, 0) + isSetting?.specialDelivery,
        delivery: value,
      };
    } else {
      objCartShop = {
        ...objCartShop,
        priceShipment: 0,
        delivery: value,
      };
    }

    const newOrders = orders;
    newOrders[index].shipment = objCartShop.priceShipment;
    newOrders[index].delivery = objCartShop.delivery;
    if (productBoxs) {
      newOrders[index].products = productBoxs;
    }
    let lengthOrders = newOrders.length;
    const Orders = newOrders.map((x: any) => ({
      boxdelivery: x?.delivery,
    }));
    let numberBox = 0;
    for (const boxDelivery of Orders) {
      const box = boxDelivery.boxdelivery === 'รับที่ร้าน';
      if (box) {
        numberBox = numberBox + 1;
      }
    }
    if (lengthOrders === numberBox) {
      setIsReadOnly(true);
    }
    if (isReset === true) {
      setIsReset(false);
    } else if (isReset === false) {
      setIsReset(true);
    }

    if (newOrders[index].delivery === 'รับที่ร้าน') {
      const odrs = newOrders.map((x: any) => ({
        ...x,
        products: x?.products.map((y: any) => ({ ...y, box: 0 })),
      }));
      setOrders(odrs);
      totalPrices();
    } else {
      setOrders(newOrders);
      totalPrices();
    }

    setIsProcessLoading(false);
  };

  const handleChange = async (
    shopId: any,
    value: any,
    index: number
  ) => {
    setIsReadOnly(false);

    const subCityId = formAddresses.getFieldValue('subCity');
    const cityId = formAddresses.getFieldValue('city');
    const stateId = formAddresses.getFieldValue('state');
    if (value === 'รับที่ร้าน') {
      let objCartShop = shipment.find((x: any) => x.shop === shopId);
      if (objCartShop) {
        setShipments(objCartShop, index, value, subCityId);
      }
    } else {
      if (subCityId && cityId && stateId) {
        let objCartShop = shipment.find(
          (x: any) => x.shop === shopId
        );
        console.log(`objCartShop ====> `, objCartShop);
        setShipments(objCartShop, index, value, subCityId);
      } else {
        message.warning(
          'กรุณากรอกที่อยู่ที่จัดส่งให้ครบก่อนคำนวณราคาค่าจัดส่ง!'
        );
        const obj: any = {};
        obj[`shipment${index}`] = null;
        formAddresses.setFieldsValue(obj);
      }
    }
  };

  const onSubCityChange = async (
    value: any = null,
    isManaulChange = false
  ) => {
    if (isManaulChange) {
      setIsLocationFromCurrent(false);
    }

    setSubCitiesCheck(value);
    if (!value) {
      value = formAddress.getFieldValue('subCity');
    }
    setCities(await getCities(value));
    if (IndexShop) {
      const obj: any = {};
      for (let i = 0; i < IndexShop; i++) {
        obj[`shipment${i}`] = null;
      }
      formAddresses.setFieldsValue(obj);
      formAddresses.setFieldsValue({});
      totalPrices();
    }
  };

  const onCityChange = async (value: any = null) => {
    if (!value) {
      value = formAddress.getFieldValue('city');
    }

    setStates(await getStates(value));
  };

  const showPosition = async () => {
    let addressNumber = null;
    if (
      currentAddresses &&
      currentAddresses.results &&
      currentAddresses.results.length
    ) {
      const result = currentAddresses.results[0];
      if (
        result &&
        result.formatted_address &&
        result.formatted_address.length
      ) {
        addressNumber = result.formatted_address
          ? result.formatted_address.split(',')[0]
          : '';
      }
    }
    const postalCodeResponse = currentAddresses?.results?.find(
      (x: any) => x.types.find((y: any) => y === 'postal_code')
    );

    if (postalCodeResponse) {
      const postalCode =
        postalCodeResponse &&
        postalCodeResponse.address_components &&
        postalCodeResponse.address_components.length
          ? postalCodeResponse.address_components[0]?.long_name
          : '';
      const isAddressNumber =
        addressNumber?.startsWith('0') ||
        addressNumber?.startsWith('1') ||
        addressNumber?.startsWith('2') ||
        addressNumber?.startsWith('3') ||
        addressNumber?.startsWith('4') ||
        addressNumber?.startsWith('5') ||
        addressNumber?.startsWith('6') ||
        addressNumber?.startsWith('7') ||
        addressNumber?.startsWith('8') ||
        addressNumber?.startsWith('9');

      if (postalCode) {
        formAddresses.setFieldsValue({
          address: isAddressNumber ? addressNumber : null,
          postalCode,
        });

        setIsAddressLocation(true);
        onPostalCodeChange(postalCode, true);
      }

      setIsLocationFromCurrent(true);
      setIsCurrentLocationLoading(false);
    }
  };

  const onCurrentLocationClick = () => {
    setIsReadOnly(false);
    showPosition();
  };

  useEffect(() => {
    if (subCities.length) {
      formAddress.setFieldsValue({
        subCity: subCities[0].value,
      });

      if (isAddressLocation) {
        formAddresses.setFieldsValue({
          subCity: subCities[0].value,
        });
      }

      onSubCityChange();
    }
  }, [subCities]);

  useEffect(() => {
    if (isOptionsDeliver.length) {
    }
  }, [isOptionsDeliver]);

  useEffect(() => {
    if (cities.length) {
      formAddress.setFieldsValue({
        city: cities && cities.length ? cities[0]?.value : null,
      });

      if (isAddressLocation) {
        formAddresses.setFieldsValue({
          city: cities && cities.length ? cities[0]?.value : null,
        });
      }

      onCityChange();
    }
  }, [cities]);

  useEffect(() => {
    if (states.length) {
      formAddress.setFieldsValue({
        state: states && states.length ? states[0].value : null,
      });

      if (isAddressLocation) {
        formAddresses.setFieldsValue({
          state: states && states.length ? states[0].value : null,
        });
        setIsAddressLocation(false);
      }
    }
  }, [states]);

  useEffect(() => {
    formAddress.setFieldsValue({ ...state });
  }, [state]);

  useEffect(() => {}, [shipmentprice]);
  useEffect(() => {}, [isReset]);

  useEffect(() => {
    setCurrentUser(user);
    if (user._id) {
      getCarts(user._id);
    }
  }, [user]);

  useEffect(() => {
    totalPrice();
    setIndexShop(orders.length);

    for (let i = 0; i < orders.length; i++) {
      if (!orders[i].shipmentDate) {
        orders[i].shipmentDate = moment().add(1, 'day');
      }
    }
  }, [orders]);

  useEffect(() => {
    if (currentUser._id) {
      setProfileImage(currentUser.photoURL);
      setProfileName(currentUser.displayName);

      getPostalCodesAPI();

      if (currentUser._id) {
        const addresses = [];
        const addressesLocation = [];
        for (let i = 0; i < currentUser?.addresses?.length; i++) {
          addresses.push({
            address: currentUser?.addresses[i]?.address,
            postalCode: currentUser?.addresses[i]?.postalCode?.name,
            subCity: currentUser?.addresses[i]?.subCity?.name,
            city: currentUser?.addresses[i]?.city?.name,
            state: currentUser?.addresses[i]?.state?.name,
            isCurrent: currentUser?.addresses[i]?.isCurrent,
          });
          addressesLocation.push({
            address: currentUser?.addresses[i]?.address,
            postalCode: currentUser?.addresses[i]?.postalCode?.name,
            subCity: currentUser?.addresses[i]?.subCity?._id,
            city: currentUser?.addresses[i]?.city?._id,
            state: currentUser?.addresses[i]?.state?._id,
            isCurrent: currentUser?.addresses[i]?.isCurrent,
          });
        }
        setState({
          addresses: addresses,
          addressesLocation: addressesLocation,
        });
      }
    }
  }, [currentUser]);

  useEffect(() => {
    if (isReadOnly) {
      formAddresses.setFieldsValue({
        address: null,
        postalCode: null,
        subCity: null,
        city: null,
        state: null,
      });
    }
  }, [isReadOnly]);

  useEffect(() => {
    if (currentAddress?.results?.length) {
      setCurrentAddresses(currentAddress);
    }
  }, [currentAddress]);

  useEffect(() => {
    if (currentAddresses) {
      onCurrentLocationClick();
    }
  }, [currentAddresses]);

  useEffect(() => {
    totalPrices();
  }, [orders]);

  const getLocation = () => {
    if (!navigator.geolocation) {
    } else {
      navigator.geolocation.getCurrentPosition(() => {});
    }
  };

  useEffect(() => {
    getOrder();
    formAddress.setFieldsValue({
      addresseses: [{}],
      addresses: [{}],
    });
    getLocation();
  }, []);

  const theme = createTheme({
    overrides: {
      MuiButton: {
        textPrimary: {
          color: '#2d6fa5',
        },
      },
      MuiPickersDay: {
        day: {
          color: 'black',
        },
        daySelected: {
          backgroundColor: '#2d6fa5',
          '&:hover': {
            backgroundColor: '#2d6fa5',
          },
        },
        dayDisabled: {
          color: '#ccc',
        },
        current: {
          color: '#2d6fa5',
        },
      },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: '#2d6fa5',
        },
      },
    },
  });

  const [isPromotionError, setIsPromotionError] = useState(false);
  const [promotionErrorText, setPromotionErrorText] = useState(
    'ไม่สามารถใช้โค้ดได้ในขณะนี้'
  );
  const [promotionCode, setPromotionCode] = useState('');
  const [usePromotion, setUsePromotion] = useState(false);
  const [isDisabledPromotionCode, setIsDisabledPromotionCode] =
    useState(false);
  const [gift, setGift] = useState({ name: '', qty: 0 });
  const [discount, setDiscount] = useState({ amount: 0, type: '' });

  const onApplyPromotionCode = async () => {
    const jsonData = {
      code: promotionCode,
      cart: isCarts.shops[0].products.map((product: any) => {
        return {
          productId:
            product.product.product.code || product.product.code,
          qty: product.amount,
          unit: 'PC',
          price: product.product.memberPrice,
        };
      }),
      sellerId: isCarts.shops[0].shop.code,
      totalAmount: orderTotalPrice,
      userId: user._id,
      channel: 'online',
    };
    try {
      const promotion = await axios
        .post(`/promotions/applyPromotion`, jsonData)
        .catch((error) => {
          setIsPromotionError(true);
          setPromotionErrorText(error.response.data.message);
        });
      if (promotion) {
        setIsPromotionError(false);
        setIsDisabledPromotionCode(true);
        setUsePromotion(true);
        if (promotion.data.type === 'freegift') {
          const gift = await axios.get(
            `/products/scg/detail/${promotion.data.giftProductCode}`
          );
          const giftName = gift.data.productName;
          setGift({
            name: giftName,
            qty: promotion.data.giftProductQty,
          });
          setDiscount({ amount: 0, type: promotion.data.type });
        } else if (promotion.data.type === 'free_shipping') {
          setDiscount({ amount: 0, type: promotion.data.type });
        } else {
          setDiscount({
            amount: promotion.data.discountAmount,
            type: promotion.data.type,
          });
        }
      }
    } catch (err) {
      setIsPromotionError(true);
    }
  };

  const onChangePromotionCode = (event: any) => {
    if (event.target.value === '' || event.target.value.length < 1) {
      setIsPromotionError(false);
    }
    setPromotionCode(event.target.value);
  };

  return (
    <>
      <Layout
        breadcrumbItems={breadcrumbs}
        breadcrumbMarginBottom={50}
      >
        <Form
          form={formAddresses}
          onFinish={confirmButton}
          layout="vertical"
        >
          <div className={styles.cartWrapper}>
            <h1 className={styles.header}>สรุปรายการสั่งซื้อ</h1>
            <Row style={{ paddingBottom: 200 }}>
              <Col xs={24} sm={24} md={10} lg={14}>
                <div className={styles.cartWrapper}>
                  <h1 className={styles.header1}>รายการสั่งซื้อ</h1>
                  <div className={styles.cartBoxWrapper}>
                    {orders.map((item: any, index: number) => (
                      <div key={index} className={styles.cartBox}>
                        {isProcessLoading && (
                          <>
                            <div className={styles.loading}>
                              loading...
                            </div>
                          </>
                        )}
                        <>
                          <div className={styles.top}>
                            <Row style={{ paddingTop: 10 }}>
                              <Col xs={24} sm={24} md={24} lg={8}>
                                <div
                                  className={styles.icon}
                                  style={{ paddingTop: 5 }}
                                >
                                  <img
                                    alt=""
                                    src={`/images/shops/shop-icon-small.svg`}
                                  />
                                  <div
                                    className={styles.text}
                                    style={{
                                      paddingTop: 3,
                                      fontSize: 12,
                                    }}
                                  >
                                    {
                                      orders[index]?.products[0]
                                        ?.product?._id?.shop?.name
                                    }
                                  </div>
                                </div>
                              </Col>
                              <Col style={{ marginTop: '5px' }}>
                                วันที่จัดส่ง&nbsp;
                              </Col>
                              <Col xs={12} sm={12} md={12} lg={6}>
                                <Form.Item name={`date${index}`}>
                                  <ThemeProvider theme={theme}>
                                    <MuiPickersUtilsProvider
                                      utils={OverwriteMomentBE}
                                      locale="th"
                                    >
                                      <Fragment>
                                        <DatePicker
                                          className={
                                            styles.datePicker
                                          }
                                          style={{ width: 130 }}
                                          size="small"
                                          minDate={moment().add(
                                            0,
                                            'days'
                                          )}
                                          format="DD/MM/yyyy"
                                          views={[
                                            'year',
                                            'month',
                                            'date',
                                          ]}
                                          value={
                                            item?.shipmentDate
                                              ? item?.shipmentDate
                                              : moment().add(
                                                  1,
                                                  'days'
                                                )
                                          }
                                          onChange={(e: any) =>
                                            onDatePickerChange(
                                              e,
                                              item,
                                              index
                                            )
                                          }
                                        />
                                      </Fragment>
                                    </MuiPickersUtilsProvider>
                                  </ThemeProvider>
                                </Form.Item>
                              </Col>
                              <Col xs={10} sm={24} md={24} lg={5}>
                                <Form.Item
                                  name={`time${index}`}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'กรุณากรอกข้อมูล!',
                                    },
                                  ]}
                                >
                                  <Select
                                    size={'small'}
                                    placeholder="เลือกเวลา"
                                    style={{ width: 130 }}
                                    onChange={(value) =>
                                      onTimePickerChange(
                                        value,
                                        item,
                                        index
                                      )
                                    }
                                  >
                                    <Option value="8/00">
                                      8.00 - 9.00 น.
                                    </Option>
                                    <Option value="9/00">
                                      9.00 - 10.00 น.
                                    </Option>
                                    <Option value="10/00">
                                      10.00 - 11.00 น.
                                    </Option>
                                    <Option value="11/00">
                                      11.00 - 12.00 น.
                                    </Option>
                                    <Option value="12/00">
                                      12.00 - 13.00 น.
                                    </Option>
                                    <Option value="13/00">
                                      13.00 - 14.00 น.
                                    </Option>
                                    <Option value="14/00">
                                      14.00 - 15.00 น.
                                    </Option>
                                    <Option value="15/00">
                                      15.00 - 16.00 น.
                                    </Option>
                                    <Option value="16/00">
                                      16.00 - 17.00 น.
                                    </Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                          {orders[index].products.map(
                            (item2: any, idx: number) => (
                              <div key={idx} className={styles.mid}>
                                <div
                                  className={styles.productWrapper}
                                >
                                  <div className={styles.productItem}>
                                    <div className={styles.product}>
                                      <div
                                        className={
                                          styles.productCover
                                        }
                                        style={{ paddingBottom: 10 }}
                                      >
                                        <img
                                          src={`${item2?.product._id?.product?.files[0]}`}
                                          alt=""
                                          style={{
                                            width: '80px',
                                            height: '100%',
                                          }}
                                          className={styles.img}
                                        />
                                      </div>
                                      <div
                                        style={{
                                          paddingLeft: 20,
                                          paddingTop: 10,
                                        }}
                                        className={
                                          styles.productDetailWrapper
                                        }
                                      >
                                        <div
                                          className={
                                            styles.productName
                                          }
                                        >
                                          {
                                            item2?.product._id
                                              ?.product?.productName
                                          }
                                        </div>
                                        <div
                                          className={styles.quantity}
                                        >
                                          {item2?.amount} ชิ้น
                                        </div>
                                        {item2?.box ===
                                          item2?.checkShipmentArea
                                            ?.length &&
                                        !item2?.isInAll ? (
                                          <div
                                            className={
                                              styles.quantity
                                            }
                                            style={{ color: 'red' }}
                                          >
                                            {' '}
                                            สินค้าอยู่นอกพื้นที่การจัดส่ง{' '}
                                          </div>
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className={styles.price}
                                      style={{ paddingTop: 20 }}
                                    >
                                      ราคา / ชิ้น{' '}
                                      {item2?.wholesalePrice
                                        .toFixed(2)
                                        .replace(
                                          /\d(?=(\d{3})+\.)/g,
                                          '$&,'
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                          <div className={styles.bottom}>
                            <div className={styles.left}>
                              <Form.Item
                                name={`shipment${index}`}
                                label={`ค่าส่ง`}
                                rules={[
                                  {
                                    required: true,
                                    message: 'กรุณากรอกข้อมูล!',
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="เลือกจัดส่ง"
                                  bordered={false}
                                  style={{ width: 120 }}
                                  onChange={(e) =>
                                    handleChange(item.shop, e, index)
                                  }
                                  options={isOptionsDeliver[index]}
                                ></Select>
                              </Form.Item>
                            </div>

                            <div className={styles.right}>
                              {' '}
                              <span
                                className={[
                                  styles.priceAll,
                                  styles.highlight,
                                ].join(' ')}
                              >
                                {!orders[index].shipment ||
                                discount.type === 'free_shipping'
                                  ? 0
                                  : (
                                      orders[index].shipment -
                                      (discount.type ===
                                      'discount_shipping'
                                        ? discount.amount
                                        : 0)
                                    )
                                      .toFixed(2)
                                      .replace(
                                        /\d(?=(\d{3})+\.)/g,
                                        '$&,'
                                      )}
                              </span>
                            </div>
                          </div>
                          <Row className={styles.bottom}>
                            <Col xs={24} sm={24} md={12} lg={10}>
                              <div className={styles.left}>
                                หมายเหตุ​:
                              </div>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={14}>
                              <div>
                                {' '}
                                <Form.Item>
                                  <Input
                                    style={{ width: '100%' }}
                                    placeholder="ฝากข้อความถึงร้านค้า"
                                    onChange={(e) =>
                                      onRemarkChange(e, item, index)
                                    }
                                  />
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                          <div className={styles.bottom}>
                            <div className={styles.left}></div>
                            <div className={styles.right}>
                              รวม{' '}
                              <span
                                className={[
                                  styles.priceAll,
                                  styles.highlight,
                                ].join(' ')}
                              >
                                {orders[index]?.totalPrice
                                  .toFixed(2)
                                  .replace(
                                    /\d(?=(\d{3})+\.)/g,
                                    '$&,'
                                  )}
                              </span>
                            </div>
                          </div>
                        </>
                      </div>
                    ))}
                  </div>
                  <div>
                    <span className={styles.textRed}>
                      หากต้องการใบกำกับภาษีกรุณากรอกชื่อ ที่อยู่
                      และเลขประจำตัวผู้เสียภาษีในช่องหมายเหตุ
                    </span>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={24} md={10} lg={10}>
                <Row style={{ marginTop: 14 }}>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <h1 style={{ fontSize: 18, float: 'left' }}>
                      ที่อยู่ในการจัดส่ง
                    </h1>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Button
                      type="text"
                      style={{
                        fontSize: 18,
                        color: '#2d6fa5',
                        float: 'right',
                      }}
                      disabled={isReadOnly}
                      onClick={showModal}
                    >
                      เลือกจากที่บันทึกไว้
                    </Button>
                  </Col>
                </Row>
                {isReadOnly && (
                  <>
                    <Alert
                      message="ไม่จำเป็นต้องกรอกที่อยู่การจัดส่ง"
                      type="warning"
                      showIcon
                      banner
                      style={{
                        marginBottom: 20,
                      }}
                    />
                  </>
                )}

                <Card className={[styles.cardMenu].join(' ')}>
                  {isProcessLoading && (
                    <>
                      <div className={styles.loading}>loading...</div>
                    </>
                  )}
                  <Row>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      className={`${styles.field}`}
                    >
                      <div className={styles.BoxLocation}>
                        <div className={styles.BoxLocationtop}>
                          {isCurrentLocationLoading ? (
                            <div
                              className={
                                styles.currentLocationLoading
                              }
                            >
                              <Spin />
                            </div>
                          ) : (
                            <>
                              <Button
                                type="text"
                                disabled={isReadOnly}
                                className={styles.BoxLocationicon}
                                onClick={onCurrentLocationClick}
                              >
                                <img
                                  alt=""
                                  src={`/images/location_on_24px.svg`}
                                />
                                <div className={styles.highlight}>
                                  ใช้ตำแหน่งปัจจุบัน
                                </div>
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        name={`address`}
                        label={`ชื่อผู้รับ ที่อยู่ และเบอร์โทรศัพท์`}
                        rules={[
                          {
                            required: isReadOnly ? false : true,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <TextArea
                          style={{ width: '100%' }}
                          name="address"
                          value={`address`}
                          placeholder="รายละเอียดที่อยู่"
                          disabled={isReadOnly}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        name={`postalCode`}
                        label={`รหัสไปรษณีย์`}
                        rules={[
                          {
                            required: isReadOnly ? false : true,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={onPostalCodeChangeBox}
                          options={postalCodes}
                          placeholder="รหัสไปรษณีย์"
                          disabled={isReadOnly}
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        name={`subCity`}
                        label={`แขวง / ตำบล`}
                        rules={[
                          {
                            required: isReadOnly ? false : true,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={(e) => {
                            onSubCityChange(e, true);
                          }}
                          options={subCities}
                          placeholder="แขวง / ตำบล"
                          disabled={isReadOnly}
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        name={`city`}
                        label={`เขต / อำเภอ`}
                        rules={[
                          {
                            required: isReadOnly ? false : true,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={onCityChange}
                          options={cities}
                          placeholder="เขต / อำเภอ"
                          disabled={isReadOnly}
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        name={`state`}
                        label={`จังหวัด`}
                        rules={[
                          {
                            required: isReadOnly ? false : true,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          options={states}
                          placeholder="จังหวัด"
                          disabled={isReadOnly}
                        ></Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                {/* Apply Promotion Code */}
                <Row
                  justify="space-between"
                  style={{ marginTop: '8px' }}
                >
                  <Col span={24}>
                    <Form.Item
                      name={`promotionCode`}
                      label="โค้ดส่วนลดพร้อมดี"
                      labelAlign="right"
                    >
                      <Input.Group compact>
                        <Input
                          disabled={isDisabledPromotionCode}
                          onChange={onChangePromotionCode}
                          style={{ width: 'calc(100% - 25%)' }}
                        />
                        <Button
                          disabled={isDisabledPromotionCode}
                          type="default"
                          onClick={onApplyPromotionCode}
                        >
                          ใช้ส่วนลด
                        </Button>
                      </Input.Group>
                      {isPromotionError ? (
                        <>
                          <span style={{ color: 'red' }}>
                            {promotionErrorText}
                          </span>
                        </>
                      ) : (
                        ``
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                {/* Apply Promotion Code */}

                <Row justify="space-between">
                  <Col>
                    <div>
                      <div style={{ fontSize: 14, color: '#333333' }}>
                        รวม
                        <span
                          className={styles.highlight}
                          style={{ paddingLeft: '8px' }}
                        >
                          {orderTotalPrice && (
                            <>
                              {orderTotalPrice
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                            </>
                          )}
                        </span>
                      </div>
                      <div>
                        {' '}
                        ส่วนลด{' '}
                        <span className={styles.highlight}>
                          -{' '}
                          {discount.amount
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                        </span>
                      </div>
                      {discount.type === 'free_shipping' ? (
                        <div className={styles.highlight}>
                          {' '}
                          ฟรีค่าขนส่ง
                        </div>
                      ) : (
                        <></>
                      )}
                      {discount.type === 'discount_shipping' ? (
                        <div className={styles.highlight}>
                          {' '}
                          ส่วนลดค่าขนส่ง -{' '}
                          {discount.amount
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                        </div>
                      ) : (
                        <></>
                      )}
                      <div style={{ fontSize: 14, color: '#333333' }}>
                        รวมทั้งหมด
                        <span
                          className={styles.highlight}
                          style={{ paddingLeft: '8px' }}
                        >
                          {orderTotalPrice && (
                            <>
                              {(
                                orderTotalPrice -
                                (discount.type === 'discount'
                                  ? discount.amount
                                  : 0)
                              )
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                            </>
                          )}
                        </span>
                      </div>
                      {discount.type === 'freegift' ? (
                        <div className={styles.highlight}>
                          <span>
                            ของแถม {gift.name.replaceAll('\n', '')}{' '}
                            {gift.qty} ชิ้น
                          </span>
                          <br />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Col>
                </Row>
                <div>
                  <Button
                    block
                    htmlType="submit"
                    type="primary"
                    size="large"
                    loading={loading}
                    disabled={isProcessLoading}
                  >
                    ชำระเงิน
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </Form>
      </Layout>

      <Modal
        title="ที่อยู่ของฉัน"
        visible={isModalVisible}
        footer={false}
        onCancel={handleCancel}
      >
        <Form
          form={formAddress}
          onFinish={confirmButton}
          layout="vertical"
        >
          <Form.List name="addresses">
            {(fields, { add, remove }) => (
              <>
                {fields.map(
                  ({ key, name, fieldKey, ...restField }: any) => (
                    <Row key={key}>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        className={`${styles.field}`}
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'address']}
                          fieldKey={[fieldKey, 'address']}
                          label={`รายละเอียดที่อยู่`}
                          rules={[
                            {
                              required: false,
                              message: 'กรุณากรอกข้อมูล!',
                            },
                          ]}
                        >
                          <TextArea
                            disabled
                            style={{ width: '100%' }}
                            name="address"
                            value={`address`}
                            placeholder="รายละเอียดที่อยู่"
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={12}
                        className={`${styles.field}`}
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'postalCode']}
                          fieldKey={[fieldKey, 'postalCode']}
                          label={`รหัสไปรษณีย์`}
                          rules={[
                            {
                              required: false,
                              message: 'กรุณากรอกข้อมูล!',
                            },
                          ]}
                        >
                          <Select
                            disabled
                            onChange={(e) => {
                              onPostalCodeChange(e);
                            }}
                            options={postalCodes}
                            placeholder="รหัสไปรษณีย์"
                          ></Select>
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={12}
                        className={`${styles.field}`}
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'subCity']}
                          fieldKey={[fieldKey, 'subCity']}
                          label={`แขวง / ตำบล`}
                          rules={[
                            {
                              required: false,
                              message: 'กรุณากรอกข้อมูล!',
                            },
                          ]}
                        >
                          <Select
                            disabled
                            onChange={(e) => {
                              onSubCityChange(e);
                            }}
                            options={subCities}
                            placeholder="แขวง / ตำบล"
                          ></Select>
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={12}
                        className={`${styles.field}`}
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'city']}
                          fieldKey={[fieldKey, 'city']}
                          label={`เขต / อำเภอ`}
                          rules={[
                            {
                              required: false,
                              message: 'กรุณากรอกข้อมูล!',
                            },
                          ]}
                        >
                          <Select
                            disabled
                            onChange={onCityChange}
                            options={cities}
                            placeholder="เขต / อำเภอ"
                          ></Select>
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={12}
                        className={`${styles.field}`}
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'state']}
                          fieldKey={[fieldKey, 'state']}
                          label={`จังหวัด`}
                          rules={[
                            {
                              required: false,
                              message: 'กรุณากรอกข้อมูล!',
                            },
                          ]}
                        >
                          <Select
                            disabled
                            options={states}
                            placeholder="จังหวัด"
                          ></Select>
                        </Form.Item>
                      </Col>

                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        className={`${[
                          styles.field,
                          styles.textRight,
                        ].join(' ')}`}
                      >
                        <Button
                          type="primary"
                          onClick={() => selectAddress(name)}
                        >
                          เลือก
                        </Button>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        className={`${styles.field}`}
                      >
                        <Divider
                          style={{
                            background: 'black',
                            margin: '15px 0',
                          }}
                        ></Divider>
                      </Col>
                    </Row>
                  )
                )}
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </>
  );
};
export default OrderSummary;
